import gql from 'graphql-tag';

const marketingAccountLink = gql`
  mutation marketingAccountLink($input: MarketingAccountLinkInput!) {
    marketingAccountLink(input: $input) {
      success
      identity {
        id
      }
    }
  }
`;

export default marketingAccountLink;
